import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ModalLumAlarmComponent } from 'src/app/components/ui/modal-lum-alarm/modal-lum-alarm.component';
import { DeviceService } from 'src/app/services/devices/device.service';
import { ModalService } from 'src/app/services/modal/modal.service';

@Component({
  selector: 'app-lum-alarms',
  imports: [CommonModule, TranslateModule],
  templateUrl: './lum-alarms.component.html',
  styleUrl: './lum-alarms.component.scss',
})
export class LumAlarmsComponent implements OnInit {

  @Input() allSettings = false;

  device = '';
  loading = false;
  alarmsData: any = null;
  orginalData: any = null;
  alarmsList: any[] = [];
  alarmsStatus: any = null;

  ALARM_MAX= 5;

  constructor(
    private _aRoute: ActivatedRoute,
    private _device: DeviceService,
    private _modal: ModalService,
  ) {}

  ngOnInit(): void {
    this._aRoute.parent?.parent?.params.subscribe((params: Params) => {
      this.device = params['serial'];
      this.loadAlarmsData();
    });
  }

  openEditAlarmModal(alarm: any): void {
    const modalRef = this._modal.open(ModalLumAlarmComponent, {
      centered: true,
      size: 'lg',
      scrollable: true,
    });
    modalRef.componentInstance.alarm = alarm;
    modalRef.componentInstance.id = alarm.id;
    modalRef.result.then(
      (alarm: any) => {
        this.updateAlarm(alarm);
      },
    );
  }

  openNewAlarmModal(): void {
    const modalRef = this._modal.open(ModalLumAlarmComponent, {
      centered: true,
      size: 'lg',
      scrollable: true,
    });



    // modalRef.componentInstance.alarm = null;
    modalRef.componentInstance.id = null;

    modalRef.result.then(
      (alarm: any) => {
        if (alarm.id == null) {
          this.createAlarm(alarm);
        } else {
          this.updateAlarm(alarm);
        }
      },
      () => {},
    );
  }

  private loadAlarmsData(): void {
    if (!this.device) {
      return;
    }

    this.loading = true;
    this.alarmsData = null;

    this._device.getModuleInfo(this.device, 'alarms').subscribe({
      next: (data) => {
        this.alarmsData = data;
        this.orginalData = structuredClone(this.alarmsData);
        this.alarmsList = this.alarmsData?.alarms ?? [];
        this.alarmsStatus = this.alarmsData?.stat ?? null;
        this.loading = false;
      },
      error: () => {
        this.alarmsData = null;
        this.loading = false;
      },
    });
  }


  deleteAlarm(alarm: any): void {
    this.loading = true;
    this._device.deleteCollection(this.device, 'alarms', 'alarms', alarm.id).subscribe({
      next: () => {
        this.loadAlarmsData();
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  createAlarm(alarm: any): void {
    this.loading = true;
    this._device.createCollection(this.device, 'alarms', 'alarms', alarm).subscribe({
      next: () => {
        this.loadAlarmsData();
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  updateAlarm(alarm: any): void {
    this.loading = true;
    const { id, cfg } = alarm;
    this._device.updateCollection(this.device, 'alarms', 'alarms', id, cfg).subscribe({
      next: () => {
        this.loadAlarmsData();
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  /** La condición se cumple ahora (`stat.triggered`), distinto de tener la alarma habilitada. */
  isAlarmTriggered(alarm: { stat?: { triggered?: unknown } }): boolean {
    const triggered = alarm?.stat?.triggered;
    return triggered === true || triggered === 1 || triggered === '1';
  }

  isAlarmEnabled(alarm: { cfg?: { enabled?: unknown } }): boolean {
    const enabled = alarm?.cfg?.enabled;
    return enabled === true || enabled === 1 || enabled === '1';
  }

  isAutoCleanEnabled(alarm: { cfg?: { auto_clean?: unknown } }): boolean {
    const autoClean = alarm?.cfg?.auto_clean;
    return autoClean === true || autoClean === 1 || autoClean === '1';
  }


  getThresholdTypeKey(alarm: { cfg?: { threshold_type?: string } }): string {
    const type = alarm?.cfg?.threshold_type;
    if (type === 'MAX') {
      return 'lumAlarmConditionGreater';
    }
    if (type === 'MIN') {
      return 'lumAlarmConditionLess';
    }
    if (type === 'MIN_MAX') {
      return 'lumAlarmThresholdMinMax';
    }
    return '';
  }

  getVariableName(alarm: { cfg?: { source_component?: string; source_action?: string } }): string {
    if (alarm.cfg?.source_component === 'temperature') {
      return 'temperature';
    }
    if (alarm.cfg?.source_component === 'powermeter') {
      if (alarm.cfg?.source_action === 'current') {
        return 'lumAlarmVariableCurrent';
      }
      if (alarm.cfg?.source_action === 'voltage') {
        return 'lumAlarmVariableVoltage';
      }
    }
    return '';
  }

  getUnitForValue(variable): string {
    if (variable.source_component === 'temperature') {
      return '°C';
    }
    if (variable.source_component === 'powermeter') {
      if (variable.source_action === 'current') {
        return 'A';
      }
      if (variable.source_action === 'voltage') {
        return 'V';
      }
    }
    return ''
  }

  getAutoCleanSeconds(alarm: { cfg?: { auto_clean_interval_ms?: unknown } }): number {
    return Math.round((Number(alarm?.cfg?.auto_clean_interval_ms) || 0) / 1000);
  }

  toggleAlarmEnabled(alarm: any, event: Event): void {
    const input = event.target as HTMLInputElement;
    const checked = input.checked;
    const previous = this.isAlarmEnabled(alarm);

    alarm.cfg.enabled = checked;

    this._device.updateCollection(this.device, 'alarms', 'alarms', alarm.id, { enabled: checked }).subscribe({
      error: () => {
        alarm.cfg.enabled = previous;
        input.checked = previous;
      },
    });
  }

}
